import {
  VideoBase,
  VideoContent,
  VideoDate,
  VideoDescription,
  VideoThumbnail,
  VideoTitle,
} from '@/app_components/Video/loaders/VideoLoader';

interface VideoDefaultLoaderProps {
  modal?: boolean;
  orientation?: 'horizontal' | 'vertical';
  showDescription?: boolean;
  className?: string;
  'data-index'?: number;
}

export const VideoDefaultLoader = ({
  className,
  modal = false,
  orientation,
  'data-index': index,
  showDescription = false,
}: VideoDefaultLoaderProps) => {
  return (
    <VideoBase
      className={className}
      modal={modal}
      orientation={orientation}
    >
      <VideoThumbnail
        className={className}
        data-index={index}
        modal={modal}
        orientation={orientation}
      />
      <VideoContent
        modal={modal}
        orientation={orientation}
      >
        <VideoTitle
          className={className}
          data-index={index}
          modal={modal}
          orientation={orientation}
        />
        {showDescription && (
          <VideoDescription
            modal={modal}
            orientation={orientation}
          />
        )}
        <VideoDate
          modal={modal}
          orientation={orientation}
        />
      </VideoContent>
    </VideoBase>
  );
};
